import { ToggleButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import BoltSVG from "../../../../../../../assets/images/svgs/Playground/ImageEditing/bolt.svg?react";
import BoxModelSVG from "../../../../../../../assets/images/svgs/Playground/ImageEditing/box-model-2.svg?react";
import SettingsSVG from "../../../../../../../assets/images/svgs/Playground/ImageEditing/settings.svg?react";
import BriaToggleButtonGroup from "../../../../../../../components/common/BriaToggleButtonGroup/BriaToggleButtonGroup";
import BriaTooltip from "../../../../../../../components/common/BriaTooltip/BriaTooltip";
import { useAppStore } from "../../../../../../../hooks/useStores";
import { GenerateBackgroundByTextMode } from "../../../../../../../models/image-to-image";
import styles from "./GenerateBackgroundModesCard.module.scss";

const GenerateBackgroundModesCard = () => {
	const { t } = useTranslation("image_editing", {
		keyPrefix: "playground.imageToImage.config.features.background.generateByTextModes",
	});
	const { imageToImageStore } = useAppStore();

	const changeMode = (mode: GenerateBackgroundByTextMode) => {
		imageToImageStore.handleConfigChange("background", {
			...imageToImageStore.config.background,
			generateByText: {
				...imageToImageStore.config.background?.generateByText,
				mode: mode,
			},
		});
	};

	return (
		<BriaToggleButtonGroup
			className={styles.textToImageModeToggle}
			value={imageToImageStore.config.background?.generateByText?.mode}
			onChange={(_, value: GenerateBackgroundByTextMode) => changeMode(value)}
		>
			<BriaTooltip title={t("tooltip.base")}>
				<ToggleButton value="base" className={styles.modeToggleButton}>
					<BoxModelSVG />
					<span className={styles.modeToggleText}>{t("base")}</span>
				</ToggleButton>
			</BriaTooltip>
			<BriaTooltip title={t("tooltip.highControl")}>
				<ToggleButton value="high_control" className={styles.modeToggleButton}>
					<SettingsSVG />
					<span className={styles.modeToggleText}>{t("highControl")}</span>
				</ToggleButton>
			</BriaTooltip>
			<BriaTooltip title={t("tooltip.fast")}>
				<ToggleButton value="fast" className={styles.modeToggleButton}>
					<BoltSVG />
					<span className={styles.modeToggleText}>{t("fast")}</span>
				</ToggleButton>
			</BriaTooltip>
		</BriaToggleButtonGroup>
	);
};

export default GenerateBackgroundModesCard;
